module.exports = __webpack_public_path__ + "static/media/call.ec11c9ef.svg";